module.exports = __webpack_public_path__ + "img/personal-information.c4320e4d.svg";